import { ComponentType } from "react";

export const withNumberInputOnly = <T,>(InputComponent: ComponentType<T>) => {
    const onInputNumberOnly = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue);

        if (isNaN(numericValue)) {
            // If the input is not a valid number, clear the input value
            e.target.value = "";
        } else {
            // If the input is a valid number, update the input value with the numeric value
            e.target.value = numericValue.toString();
        }
    };
    return (props: T) => {
        return <InputComponent {...props} onInput={onInputNumberOnly} />;
    };
};
